import repository from '@/utils/repository';

export default {
    searchMst008Info: (data) => {
        return repository.post('/move/postCommonMst008Info', {
            ...data
        });
    }
};
